import axiosInstance from '../services/AxiosInstance';

export const getMerchants = (getData) => {
  return axiosInstance.get("merchants/list", {
    params: getData,
  });
};




export const merchantList = (getData) => {
  return axiosInstance.get("merchants/merchant-list", {
    params: getData,
  });
};

export const getMerchantCount = (getData) => {
  return axiosInstance.get("merchants/merchant-count", {
    params: getData,
  });
};

export const addMerchants = (data) => {
  return axiosInstance.post("merchants/create", data);
};

export const updateMerchants = (id, data) => {
  return axiosInstance.put(`merchants/update/${id}`, data);
};

export const merchantsDocData = (id, data) => {
  return axiosInstance.get(`merchants/merchant-details/${id}`, data);
};

export const fetchMerchantsById = async (id) => {
    const response = await axiosInstance.get(`merchants/show/${id}`);
    return response.data;
};

export const updateMerchantPassword = (id, data) => {
  // Placeholder endpoint; update when actual API path is provided
  return axiosInstance.put(`merchants/update-password/${id}`, data);
};
